<mat-toolbar class="main-header">
  <button mat-icon-button (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <span>Participantes</span>
  <span class="spacer"></span>
  <button
    mat-icon-button
    (click)="sendPaymentReminders()"
    title="Enviar recordatorios de formalización"
  >
    <mat-icon>notifications</mat-icon>
  </button>
</mat-toolbar>

<div class="ul-wrapper">
  @if (users) {
    <div class="ul-search">
      <mat-icon>search</mat-icon>
      <input
        type="search"
        [(ngModel)]="searchQuery"
        placeholder="Buscar participante por nombre"
        aria-label="Buscar participante por nombre"
      />
      @if (searchQuery) {
        <button
          type="button"
          (click)="searchQuery = ''"
          aria-label="Limpiar búsqueda"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>

    <!-- Stats strip -->
    <div class="ul-stats">
      <button
        type="button"
        class="ul-stat"
        [class.active]="paymentFilter === 'all'"
        (click)="setPaymentFilter('all')"
      >
        <span class="ul-stat__value">{{ users.length }}</span>
        <span class="ul-stat__label">Participantes</span>
      </button>
      <div class="ul-stat-divider"></div>
      <button
        type="button"
        class="ul-stat"
        [class.active]="paymentFilter === 'paid'"
        (click)="setPaymentFilter('paid')"
      >
        <span class="ul-stat__value success">{{ paidCount }}</span>
        <span class="ul-stat__label">OK</span>
      </button>
      <div class="ul-stat-divider"></div>
      <button
        type="button"
        class="ul-stat"
        [class.active]="paymentFilter === 'unpaid'"
        (click)="setPaymentFilter('unpaid')"
      >
        <span class="ul-stat__value danger">{{
          users.length - paidCount
        }}</span>
        <span class="ul-stat__label">No OK</span>
      </button>
    </div>

    <!-- User list -->
    <div class="ul-list">
      @for (user of filteredUsers; track user._id) {
        <div class="ul-card">
          <div class="ul-card__avatar" (click)="editUser(user)">
            <app-avatar [user]="user"></app-avatar>
          </div>
          <div class="ul-card__info" (click)="editUser(user)">
            <span class="ul-card__name">{{ user.name }}</span>
            <!-- <span
              class="ul-card__badge"
              [class.paid]="user.hasPaid"
              [class.unpaid]="!user.hasPaid"
            >
              {{ user.hasPaid ? "Formalizado" : "Sin formalizar" }}
            </span> -->
          </div>
          <div class="ul-card__actions">
            @if (user.role !== 1) {
              <button
                class="ul-action-btn ul-action-btn--impersonate"
                (click)="impersonate(user)"
                title="Entrar como este participante"
              >
                <mat-icon>switch_account</mat-icon>
              </button>
            }
            <button
              class="ul-action-btn"
              [class.paid]="user.hasPaid"
              [class.unpaid]="!user.hasPaid"
              (click)="togglePayment(user)"
              title="Cambiar estado de formalización"
            >
              <mat-icon>how_to_reg</mat-icon>
            </button>
            <button
              class="ul-action-btn ul-action-btn--delete"
              (click)="delete(user)"
              title="Eliminar usuario"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      }
      @if (filteredUsers.length === 0) {
        <div class="ul-empty">
          <mat-icon>person_search</mat-icon>
          <strong>No hay participantes</strong>
          <span>Prueba con otra búsqueda o filtro.</span>
        </div>
      }
    </div>
  }
</div>
